import * as Icon from "@ant-design/icons";
import { Button, Col, DatePicker, DatePickerProps, Divider, Flex, Form, Image, Input, Modal, Radio, RadioChangeEvent, Row, Select, Space, Table, Tooltip, UploadFile } from "antd";
import Title from "antd/es/typography/Title";
import TextArea from "antd/lib/input/TextArea";
import dayjs from "dayjs";
import "dayjs/locale/pt-br";
import * as PhosphorIcon from "phosphor-react";
import React, { useEffect, useState } from "react";
import { NumericFormat } from "react-number-format";
import SelectTree from "../../../../components/inputs/selectTree";
import UploadArquivosComponent from "../../../../components/uploadArquivosComponent";
import { AnexoItemModel } from "../../../../models/arquivoAnexo/anexoItemModel";
import { ArquivoAnexoModel } from "../../../../models/arquivoAnexo/arquivoAnexoModel";
import { TipoArquivoAnexoModel } from "../../../../models/arquivoAnexo/tipoArquivoAnexoModel";
import { CategoriaEmpresaModel } from "../../../../models/categoriaEmpresa/categoriaEmpresaModel";
import { Vm_ContaBancoModel } from "../../../../models/contaBanco/vm_contaBancoModel";
import { ContaFinanceiraDTOModel } from "../../../../models/contaFinanceira/contaFinanceiraDTOModel";
import { GerarCalculoRateioModel } from "../../../../models/contaFinanceira/gerarCalculoRateioModel";
import { RateioJsonModel } from "../../../../models/contaFinanceira/rateioJsonModel";
import { EmpresaModel } from "../../../../models/empresa/empresaModel";
import { ListaEmpresaDTOModel } from "../../../../models/empresa/listaEmpresaDTOModel";
import { PessoaModel } from "../../../../models/pessoa/pessoaModel";
import { setDataSourceAnexo, setEditingKeyAnexo, setModalArquivo } from "../../../../redux/slices/arquivoAnexo/arquivoAnexoSlice";
import { setTitle } from "../../../../redux/slices/configuracoes/configuracoesSlice";
import { setModalPessoaContaFinanceira, setModalVoltarContaFinanceira, setPageContaFinanceira } from "../../../../redux/slices/contaFinanceira/contaFinanceiraSlice";
import { setPageLancamentoBancario } from "../../../../redux/slices/lancamentoBancario/lancamentoBancarioSlice";
import { listarArquivoAnexo, listarTipoArquivoAnexo } from "../../../../services/arquivoAnexoService";
import { buscarCategoriaEmpresa } from "../../../../services/categoriaEmpresaService";
import { buscarCentroCusto } from "../../../../services/centroCustoService";
import { buscarContaBanco } from "../../../../services/contaBancoService";
import {
  atualizarContaFinanceira,
  cadastrarContaFinanceira,
  gerarCalculoRateio,
  listarDetalheContaFinanceira,
  listarSituacaoContaFinanceira,
  listaUltimoHistoricoFornecedor,
} from "../../../../services/contaFinanceiraService";
import { listarTipoContatoPessoa } from "../../../../services/contatoPessoaService";
import { buscarEmpresa } from "../../../../services/empresaService";
import { listarEstado } from "../../../../services/localizacaoService";
import { buscarPessoa, listarCategoriaPessoa } from "../../../../services/pessoaService";
import { buscarPlanoContaFinanceiro } from "../../../../services/planoContaFinanceiroService";
import { listarSorteio } from "../../../../services/sorteioService";
import { buscarTipoDocumento } from "../../../../services/tipoDocumentoService";
import { currencyBRL, realParaNumber } from "../../../../util/dinheiroBRAuxiliar";
import { formatPorcentagem } from "../../../../util/formats";
import { findNodeById } from "../../../../util/functions/findNodeById";
import { useAppDispatch, useAppSelector } from "../../../../util/hooks";
import { toastWarning } from "../../../../util/toast";
import ModalPessoaContaFinanceira from "./modals";
import "./style/index.scss";

dayjs.locale("pt-br");

interface Item {
  key: string;
  idPlanoContaFinanceiro: number | null;
  idCentroCusto: number | null;
  valor: number | null;
}

interface EditableCellProps extends React.HTMLAttributes<HTMLElement> {
  editing: boolean;
  dataIndex: string;
  title: any;
  inputType: "number" | "selectConta" | "selectCentro";
  record: Item;
  index: number;
  children: React.ReactNode;
}

const CadastrarPage = () => {
  //estados globais
  const contaFinanceiraState = useAppSelector((state) => state.contaFinanceira);
  const empresaState = useAppSelector((state) => state.empresa);
  const pessoaState = useAppSelector((state) => state.pessoa);
  const contaBancoState = useAppSelector((state) => state.contaBanco);
  const tipoDocumentoState = useAppSelector((state) => state.tipoDocumento);
  const planoContaFinanceiroState = useAppSelector((state) => state.planoContaFinanceiro);
  const centroCustoState = useAppSelector((state) => state.centroCusto);
  const rateioCentroCustoState = useAppSelector((state) => state.rateioCentroCusto);
  const arquivoAnexoState = useAppSelector((state) => state.arquivoAnexo);
  const sorteioState = useAppSelector((state) => state.sorteio);
  const persistedState = useAppSelector((state) => state.persisted);
  const categoriaEmpresaState = useAppSelector((state) => state.categoriaEmpresa);
  const lancamentoBancarioState = useAppSelector((state) => state.lancamentoBancario);

  //hooks
  const dispatch = useAppDispatch();

  //estados locais
  const [form] = Form.useForm();
  const [formManual] = Form.useForm();
  const [formRateio] = Form.useForm();
  const [valueRadio, setValueRadio] = useState("Manual");
  const [count, setCount] = useState(1);
  const [editingKey, setEditingKey] = useState("");
  const [total, setTotal] = useState<number>(0);
  const [totalItens, setTotalItens] = useState<number>(0);
  const [dataSource, setData] = useState<Item[]>([]);
  const [dataSourceOriginal, setDataOriginal] = useState<Item[]>([]);
  const [exigeSorteio, setExigeSorteio] = useState<boolean>(false);

  const pagar = contaFinanceiraState.origemCadastro === "contaFinanceira" && contaFinanceiraState.tipoCadastro === "despesa";
  const lancamentoDespesa = contaFinanceiraState.origemCadastro === "lancamento" && contaFinanceiraState.tipoCadastro === "despesa";
  const lancamentoReceita = contaFinanceiraState.origemCadastro === "lancamento" && contaFinanceiraState.tipoCadastro === "receita";

  const editar = Object.values(contaFinanceiraState.entity).length !== 0;

  const radioOptions = [
    { label: "Manual", value: "Manual" },
    { label: "Rateio", value: "Rateio" },
  ];

  const fetchData = async () => {
    const retorno = await dispatch(listarDetalheContaFinanceira(contaFinanceiraState.entity.id));
    setCount(retorno.payload.length);
    var initialData: Item[] = [];
    for (let i = 0; i < retorno.payload.length; i++) {
      initialData.push({
        key: i.toString(),
        idPlanoContaFinanceiro: retorno.payload[i].idPlanoContaFinanceiro,
        idCentroCusto: retorno.payload[i].idCentroCusto,
        valor: retorno.payload[i].valor,
      });
    }
    var initialDataOriginal: Item[] = [];
    for (let i = 0; i < retorno.payload.length; i++) {
      initialDataOriginal.push({
        key: i.toString(),
        idPlanoContaFinanceiro: retorno.payload[i].idPlanoContaFinanceiro,
        idCentroCusto: retorno.payload[i].idCentroCusto,
        valor: retorno.payload[i].valor,
      });
    }
    let soma = retorno.payload.reduce((prev: any, current: any) => {
      return prev + +(current.valor === null ? 0 : realParaNumber(current.valor.toString()));
    }, 0);
    setTotalItens(Math.trunc(parseInt((soma * 100).toFixed(2))) / 100);
    setData(initialData);
    setDataOriginal(initialDataOriginal);
  };

  useEffect(() => {
    if (categoriaEmpresaState.list.length === 0) dispatch(buscarCategoriaEmpresa());
    if (tipoDocumentoState.list.length === 0) dispatch(buscarTipoDocumento(tipoDocumentoState.busca));
    if (empresaState.list.length === 0) dispatch(buscarEmpresa(empresaState.busca));
    if (contaFinanceiraState.listSituacao.length === 0) dispatch(listarSituacaoContaFinanceira());
    dispatch(
      buscarCentroCusto({ ...centroCustoState.busca, receita: contaFinanceiraState.tipoCadastro === "receita" ? true : null, despesa: contaFinanceiraState.tipoCadastro === "despesa" ? true : null })
    );

    if (arquivoAnexoState.listTipo.length === 0) dispatch(listarTipoArquivoAnexo("cfin"));
    dispatch(
      buscarPessoa({
        ...pessoaState.busca,
        idCategoriaPessoa: null,
        exibeContaPagar: pagar || contaFinanceiraState.origemCadastro === "guia" || lancamentoDespesa || lancamentoDespesa ? true : null,
        exibeContaReceber: pagar || contaFinanceiraState.origemCadastro === "guia" || lancamentoDespesa || lancamentoDespesa ? null : true,
      })
    );

    if (editar) {
      onChangeEmpresa(contaFinanceiraState.entity.idEmpresa);

      var editarCopiar = contaFinanceiraState.tipoAcao === "duplicar" ? "DUPLICAR" : "EDITAR";
      var tituloTela =
        pagar || contaFinanceiraState.origemCadastro === "guia" || lancamentoDespesa || lancamentoDespesa
          ? editarCopiar + " CONTA A PAGAR"
          : contaFinanceiraState.origemCadastro === "pendencia"
          ? "INFORMAÇÕES"
          : editarCopiar + " CONTA A RECEBER";

      dispatch(setTitle(tituloTela));

      if (!(contaFinanceiraState.tipoAcao === "duplicar")) {
        // Só carregar os anexos se não for uma cópia
        dispatch(listarArquivoAnexo(contaFinanceiraState.entity.id));
      }

      fetchData();
      form.setFieldsValue({
        ...contaFinanceiraState.entity,
        idSorteio: contaFinanceiraState.entity.idSorteio === 0 ? null : contaFinanceiraState.entity.idSorteio,
        dataEmissao: dayjs(new Date(contaFinanceiraState.entity.dataEmissao)),
        dataVencimento: dayjs(new Date(contaFinanceiraState.entity.dataVencimento)),
        dataCompetencia: dayjs(new Date(contaFinanceiraState.entity.dataCompetencia)),
      });

      if (contaFinanceiraState.tipoAcao === "duplicar") {
        form.setFieldValue("idSituacaoContaFinanceira", 2);
        form.setFieldValue("valorPago", 0);
      }

      setTotal(contaFinanceiraState.entity.valorBruto);
    } else {
      if (persistedState.user.empresa !== null) {
        onChangeEmpresa(persistedState.user.empresa.idEmpresa);
      }
      dispatch(setDataSourceAnexo([]));

      var initialData: Item[] = [];
      for (let i = 0; i < count; i++) {
        initialData.push({
          key: i.toString(),
          idPlanoContaFinanceiro: null,
          idCentroCusto: null,
          valor: null,
        });
      }
      var initialDataOriginal: Item[] = [];
      for (let i = 0; i < count; i++) {
        initialDataOriginal.push({
          key: i.toString(),
          idPlanoContaFinanceiro: null,
          idCentroCusto: null,
          valor: null,
        });
      }
      setData(initialData);
      setDataOriginal(initialDataOriginal);
      setEditingKey(initialData[0].key);
      form.setFieldValue("idSituacaoContaFinanceira", 2);
      form.setFieldValue("valorPago", 0);
      if (lancamentoReceita || lancamentoDespesa) {
        form.setFieldValue("idEmpresa", lancamentoBancarioState.busca.idEmpresa);
        onChangeEmpresa(lancamentoBancarioState.busca.idEmpresa);
      } else {
        form.setFieldValue("idEmpresa", contaFinanceiraState.busca.idEmpresa);
        onChangeEmpresa(contaFinanceiraState.busca.idEmpresa ?? 0);
      }
      dispatch(setTitle(pagar || contaFinanceiraState.origemCadastro === "guia" || lancamentoDespesa || lancamentoDespesa ? "NOVA CONTA A PAGAR" : "NOVA CONTA A RECEBER"));
    }
  }, [contaFinanceiraState.entity]);

  const goModalPessoa = () => {
    dispatch(listarTipoContatoPessoa());
    dispatch(listarCategoriaPessoa());
    dispatch(listarEstado());
    dispatch(setModalPessoaContaFinanceira(true));
  };

  const closeModalPessoa = () => {
    dispatch(setModalPessoaContaFinanceira(false));
  };

  //início funções tabela centro de custo
  const EditableCell: React.FC<React.PropsWithChildren<EditableCellProps>> = ({ editing, dataIndex, title, inputType, record, index, children, ...restProps }) => {
    const inputNode =
      inputType === "number" ? (
        <NumericFormat
          className="ant-input noBoderColor number-input"
          thousandSeparator="."
          decimalSeparator=","
          decimalScale={2}
          prefix="R$"
          fixedDecimalScale={true}
          onValueChange={(e) => {
            formManual.setFieldValue("valor", e.floatValue);
          }}
        />
      ) : inputType === "selectConta" ? (
        <SelectTree loading={planoContaFinanceiroState.loading} list={planoContaFinanceiroState.list} style={{ width: "100%" }} />
      ) : (
        <SelectTree loading={centroCustoState.loading} list={centroCustoState.list} style={{ width: "100%" }} />
      );

    return (
      <td {...restProps}>
        {editing ? (
          <Form.Item
            name={dataIndex}
            style={{ margin: 0 }}
            rules={[
              {
                required: true,
                message: `Informe o ${title}`,
              },
            ]}
          >
            {inputNode}
          </Form.Item>
        ) : (
          children
        )}
      </td>
    );
  };

  const isEditing = (record: Item) => record.key === editingKey;

  const edit = (record: Partial<Item> & { key: React.Key }) => {
    formManual.setFieldsValue({
      idPlanoContaFinanceiro: record.idPlanoContaFinanceiro,
      idCentroCusto: record.idCentroCusto,
      valor: record.valor,
    });
    setEditingKey(record.key);
  };

  const handleDelete = (key: React.Key) => {
    const newData = dataSource.filter((item: any) => item.key !== key);
    let soma = newData.reduce((prev, current) => {
      return prev + +(current.valor === null ? 0 : realParaNumber(current.valor.toString()));
    }, 0);
    setTotalItens(Math.trunc(parseInt((soma * 100).toFixed(2))) / 100);
    setData(newData);
  };

  const cancel = (key: React.Key) => {
    const hasData = dataSource.find((item: any) => item.key === key);
    if (hasData?.idPlanoContaFinanceiro === null) {
      handleDelete(key);
    }
    setEditingKey("");
  };

  const handleAdd = () => {
    if (editingKey === "") {
      const newData: Item = {
        key: count.toString(),
        idPlanoContaFinanceiro: null,
        idCentroCusto: null,
        valor: null,
      };
      setData(dataSource.concat(newData));
      setCount(count + 1);
      setEditingKey(count.toString());
      formManual.resetFields();
      if (totalItens === 0) {
        formManual.setFieldValue("valor", total);
      }
    } else {
      toastWarning("Para adicionar uma nova classificação, salve primeiro a classificação que já está em edição.");
    }
  };

  const save = async (key: React.Key, abrir: boolean) => {
    try {
      const row = (await formManual.validateFields()) as Item;
      const newData = [...dataSource];
      const index = newData.findIndex((item) => key === item.key);
      if (index > -1) {
        const item = newData[index];
        newData.splice(index, 1, {
          ...item,
          ...row,
        });
        setData(newData);
        let soma = newData.reduce((prev, current) => {
          return prev + +(current.valor === null ? 0 : realParaNumber(current.valor.toString()));
        }, 0);
        setTotalItens(Math.trunc(parseInt((soma * 100).toFixed(2))) / 100);
        setEditingKey("");
        if (abrir) {
          const newData: Item = {
            key: count.toString(),
            idPlanoContaFinanceiro: null,
            idCentroCusto: null,
            valor: null,
          };
          setData(dataSource.concat(newData));
          setCount(count + 1);
          setEditingKey(count.toString());
          formManual.resetFields();
          if (totalItens === 0) {
            formManual.setFieldValue("valor", total);
          }
        }
      } else {
        newData.push(row);
        setData(newData);
        setEditingKey("");
        if (abrir) {
          const newData: Item = {
            key: count.toString(),
            idPlanoContaFinanceiro: null,
            idCentroCusto: null,
            valor: null,
          };
          setData(dataSource.concat(newData));
          setCount(count + 1);
          setEditingKey(count.toString());
          formManual.resetFields();
          if (totalItens === 0) {
            formManual.setFieldValue("valor", total);
          }
        }
      }
    } catch (e) {}
  };

  const columns = [
    {
      title: "PLANO DE CONTA FINANCEIRO",
      dataIndex: "idPlanoContaFinanceiro",
      editable: true,
      render: (_: any, record: any) => findNodeById(planoContaFinanceiroState.list, record.idPlanoContaFinanceiro)?.denominacao,
    },
    {
      title: "CENTRO DE CUSTO",
      dataIndex: "idCentroCusto",
      editable: true,
      render: (_: any, record: any) => findNodeById(centroCustoState.list, record.idCentroCusto)?.denominacao,
    },
    {
      title: "VALOR BRUTO",
      dataIndex: "valor",
      editable: true,
      align: "right" as "right",
      width: 150,
      render: (_: any, { valor }: any) => currencyBRL(valor === null ? 0 : valor),
    },
    {
      title: "AÇÕES",
      dataIndex: "acoes",
      align: "center" as "center",
      render: (_: any, record: Item) => {
        const editable = isEditing(record);
        return editable ? (
          <Flex justify="center" align="center" gap={4}>
            <Tooltip title="Salvar">
              <PhosphorIcon.CheckCircle style={{ cursor: "pointer" }} size={20} color="#334155" onClick={() => save(record.key, false)} />
            </Tooltip>
            <Tooltip title="Cancelar">
              <PhosphorIcon.XCircle style={{ cursor: "pointer" }} size={20} color="#334155" onClick={() => cancel(record.key)} />
            </Tooltip>
            <Tooltip title="Salvar e adicionar uma nova linha">
              <PhosphorIcon.PlusCircle style={{ cursor: "pointer" }} size={20} color="#334155" onClick={() => save(record.key, true)} />
            </Tooltip>
          </Flex>
        ) : (
          <Flex justify="center" gap={4}>
            <Tooltip title="Editar">
              <PhosphorIcon.Pencil style={{ cursor: "pointer" }} size={20} color="#334155" onClick={() => edit(record)} />
            </Tooltip>
            <Tooltip title="Remover">
              <PhosphorIcon.Trash style={{ cursor: "pointer" }} size={20} color="#334155" onClick={() => handleDelete(record.key)} />
            </Tooltip>
          </Flex>
        );
      },
    },
  ];

  const columnsPendencia = [
    {
      title: "PLANO DE CONTA FINANCEIRO",
      dataIndex: "idPlanoContaFinanceiro",
      editable: true,
      render: (_: any, record: any) => findNodeById(planoContaFinanceiroState.list, record.idPlanoContaFinanceiro)?.denominacao,
    },
    {
      title: "CENTRO DE CUSTO",
      dataIndex: "idCentroCusto",
      editable: true,
      render: (_: any, record: any) => findNodeById(centroCustoState.list, record.idCentroCusto)?.denominacao,
    },
    {
      title: "VALOR BRUTO",
      dataIndex: "valor",
      editable: true,
      align: "right" as "right",
      render: (_: any, { valor }: any) => currencyBRL(valor === null ? 0 : valor),
    },
  ];

  const mergedColumns =
    contaFinanceiraState.origemCadastro === "pendencia"
      ? columnsPendencia.map((col) => {
          if (!col.editable) {
            return col;
          }
          return {
            ...col,
            onCell: (record: Item) => ({
              record,
              inputType: col.dataIndex === "valor" ? "number" : col.dataIndex === "idCentroCusto" ? "selectCentro" : "selectConta",
              dataIndex: col.dataIndex,
              title: col.title,
              editing: isEditing(record),
            }),
          };
        })
      : columns.map((col) => {
          if (!col.editable) {
            return col;
          }
          return {
            ...col,
            onCell: (record: Item) => ({
              record,
              inputType: col.dataIndex === "valor" ? "number" : col.dataIndex === "idCentroCusto" ? "selectCentro" : "selectConta",
              dataIndex: col.dataIndex,
              title: col.title,
              editing: isEditing(record),
            }),
          };
        });

  const submit = (value: any) => {
    const submitContaFinanceira: ContaFinanceiraDTOModel = { ...value };
    submitContaFinanceira.origem = contaFinanceiraState.origemCadastro === "guia" ? "GUIA" : null;
    if (pagar || contaFinanceiraState.origemCadastro === "guia" || lancamentoDespesa || lancamentoDespesa) {
      submitContaFinanceira.receitaDespesa = "D";
    } else {
      submitContaFinanceira.receitaDespesa = "R";
      submitContaFinanceira.idPessoaFavorecido = submitContaFinanceira.idPessoa;
    }
    //detalhes
    const dataChange: RateioJsonModel[] = [];
    if (valueRadio === "Manual") {
      dataSource.forEach((v: any) => {
        var detalhes = {
          idCentroCusto: v.idCentroCusto,
          idPlanoContaFinanceiro: v.idPlanoContaFinanceiro,
          valor: realParaNumber(v.valor),
        };
        dataChange.push(detalhes);
      });
    } else {
      contaFinanceiraState.listCalculo.forEach((v: any) => {
        var detalhes = {
          idCentroCusto: v.idCentroCusto,
          idPlanoContaFinanceiro: formRateio.getFieldValue("idPlanoContaFinanceiro"),
          valor: v.valorRateado,
        };
        dataChange.push(detalhes);
      });
    }

    //retorna validação
    const valida = validaCentroCusto(dataChange);

    if (!valida) {
      if (valueRadio === "Manual" && total !== totalItens) {
        toastWarning("O valor total da classificação da conta difere do valor bruto");
      } else {
        submitContaFinanceira.detalhes = dataChange;

        if (persistedState.user.empresa !== null && persistedState.user.perfil !== "AUDITORIA" && persistedState.user.perfil !== "CONTABILIDADE") {
          submitContaFinanceira.idEmpresa = persistedState.user.empresa?.idEmpresa;
        }

        if (editar && !(contaFinanceiraState.tipoAcao === "duplicar")) {
          submitContaFinanceira.id = contaFinanceiraState.entity.id;
          dispatch(atualizarContaFinanceira({ value: submitContaFinanceira, origem: contaFinanceiraState.origemCadastro }));
          // } else if (editar && contaFinanceiraState.tipoAcao === "duplicar") {
          //   submitContaFinanceira.id = contaFinanceiraState.entity.id;
          //   dispatch(duplicarContaFinanceira({ value: submitContaFinanceira, origem: contaFinanceiraState.origemCadastro }));
        } else {
          dispatch(cadastrarContaFinanceira({ value: submitContaFinanceira, imagens: arquivoAnexoState.dataSourceAnexo, origem: contaFinanceiraState.origemCadastro }));
        }
      }
    }
  };

  const validaCentroCusto = (value: RateioJsonModel[]) => {
    var erro: boolean = false;
    if (value.length === 0) {
      erro = true;
      toastWarning("Informar pelo menos uma classificação de contas a pagar");
    } else {
      for (var i = 0; i < value.length; i++) {
        if (value[i].valor === null || value[i].idCentroCusto === null || value[i].idPlanoContaFinanceiro === null) {
          toastWarning("Pelo menos uma das classificações de contas a pagar está incorreta");
          erro = true;
        } else {
          erro = false;
        }
      }
    }
    return erro;
  };

  const closeModalVoltar = () => {
    dispatch(setModalVoltarContaFinanceira(false));
  };

  const voltar = () => {
    if (contaFinanceiraState.origemCadastro === "lancamento") {
      dispatch(setPageLancamentoBancario("geral"));
    } else {
      dispatch(setPageContaFinanceira("geral"));
    }
  };

  const verificarVoltar = () => {
    if (JSON.stringify(dataSource) !== JSON.stringify(dataSourceOriginal)) {
      dispatch(setModalVoltarContaFinanceira(true));
    } else {
      voltar();
    }
  };

  const onChangeRadio = ({ target: { value } }: RadioChangeEvent) => {
    setValueRadio(value);
  };

  const onChangeDataEmissao = (value: DatePickerProps["value"], dateString: string | string[]) => {
    if (form.getFieldValue("dataCompetencia") === undefined && dateString !== null) {
      form.setFieldValue("dataCompetencia", dayjs(value));
    }
  };

  const onChangeEmpresa = (value: number) => {
    // validar se exige sorteio ou não
    const searchEmpresa = empresaState.list.find((empresa: ListaEmpresaDTOModel) => empresa.id == value);
    const categoriaEmpresa = categoriaEmpresaState.list.find((categoria: CategoriaEmpresaModel) => categoria.id == searchEmpresa?.idCategoriaEmpresa);
    if (categoriaEmpresa) {
      setExigeSorteio(categoriaEmpresa.exigeSorteioContaFinanceira);
    }

    //listar sorteios
    const searchEmpresaSorteios = empresaState.list.filter((empresa: any) => empresa.idEmpresaMarketing === value);
    var listIdEmpresas = searchEmpresaSorteios.length !== 0 ? searchEmpresaSorteios[0].id + "," + value : value.toString();
    dispatch(listarSorteio(listIdEmpresas));

    dispatch(buscarContaBanco({ pesquisar: null, id: null, idEmpresa: value }));

    if (persistedState.user.empresa !== null) {
      dispatch(
        buscarPlanoContaFinanceiro({
          ...planoContaFinanceiroState.busca,
          receitaDespesa: null,
          idGrupoPlanoContaFinanceiro: empresaState.list[0].idGrupoPlanoContaFinanceiro,
        })
      );
    } else {
      dispatch(
        buscarPlanoContaFinanceiro({
          ...planoContaFinanceiroState.busca,
          receitaDespesa: null,
          idGrupoPlanoContaFinanceiro: searchEmpresa!.idGrupoPlanoContaFinanceiro,
        })
      );
    }
    formManual.setFieldValue("idPlanoContaFinanceiro", undefined);
  };

  const gerarRateio = () => {
    const gerar: GerarCalculoRateioModel = {
      valor: form.getFieldValue("valorBruto"),
      idRateio: formRateio.getFieldValue("idRateio"),
    };
    dispatch(gerarCalculoRateio(gerar));
  };

  const onChangePessoa = async (value: any) => {
    const idEmpresa = form.getFieldValue("idEmpresa");
    if (!idEmpresa) {
      toastWarning("Selecione uma empresa antes de escolher o fornecedor");
      return;
    }

    const retorno = await dispatch(listaUltimoHistoricoFornecedor({ idPessoa: value, idEmpresa }));

    if (retorno.type.includes("fulfilled")) {
      form.setFieldValue("historico", retorno.payload.historico);
    } else {
      toastWarning("Não foi encontrado histórico anterior para o fornecedor selecionado");
      form.setFieldValue("historico", "");
    }

    if (form.getFieldValue("idPessoaFavorecido") === undefined) {
      form.setFieldValue("idPessoaFavorecido", value);
    }
  };

  const goAnexarArquivo = async () => {
    if (editar && !(contaFinanceiraState.tipoAcao === "duplicar")) {
      const retorno = await dispatch(listarArquivoAnexo(contaFinanceiraState.entity.id));

      let imagens = retorno.payload.filter((a: ArquivoAnexoModel) => arquivoAnexoState.listTipo.some((tipo: TipoArquivoAnexoModel) => tipo.id === a.idTipoArquivoAnexo));
      if (imagens.length !== 0) {
        var initialData: AnexoItemModel[] = [];
        for (let i = 0; i < imagens.length; i++) {
          initialData.push({
            key: i.toString(),
            arquivo: {
              uid: "-1",
              name: imagens[i].nome,
              status: "done",
              type: imagens[i].extensaoArquivo,
              url: imagens[i].caminhoArquivo,
            },
            caminhoArquivo: imagens[i].caminhoArquivo,
            idTipoArquivoAnexo: imagens[i].idTipoArquivoAnexo,
            observacao: imagens[i].observacao,
          });
        }
        dispatch(setDataSourceAnexo(initialData));
        dispatch(setEditingKeyAnexo(""));
      } else {
        var initialData: AnexoItemModel[] = [];
        for (let i = 0; i < 1; i++) {
          initialData.push({
            key: "1",
            arquivo: {} as UploadFile,
            caminhoArquivo: null,
            idTipoArquivoAnexo: null,
            observacao: null,
          });
        }
        dispatch(setEditingKeyAnexo(initialData[0].key));
        dispatch(setDataSourceAnexo(initialData));
      }
    }
    dispatch(setModalArquivo(true));
  };

  const closeModalArquivo = async () => {
    dispatch(setModalArquivo(false));
  };

  const columnsRateio = [
    {
      title: "DISTRIBUIÇÃO",
      dataIndex: "porcentagem",
      render: (porcentagem: number) => formatPorcentagem(porcentagem),
    },
    {
      title: "CENTRO DE CUSTO",
      dataIndex: "idCentroCusto",
      render: (_: any, record: any) => findNodeById(centroCustoState.list, record.idCentroCusto)?.denominacao,
    },
    {
      title: "VALOR",
      dataIndex: "valorRateado",
      align: "right" as "right",
      render: (_: any, { valorRateado }: any) => currencyBRL(valorRateado),
    },
  ];

  return (
    <Flex gap={12} vertical>
      <Flex justify="space-between" align="center">
        <Flex onClick={verificarVoltar} className="voltar">
          {"<"} VOLTAR
        </Flex>

        <Button className="buttonPrimary" onClick={goAnexarArquivo} icon={<Icon.PaperClipOutlined />}>
          ANEXOS
        </Button>
      </Flex>
      <Form form={form} layout="vertical" onFinish={submit}>
        <Row gutter={12}>
          {persistedState.user.empresa === null && (
            <>
              <Col span={7}>
                <Form.Item
                  label="Empresa"
                  name="idEmpresa"
                  rules={[
                    {
                      required: true,
                      message: "Selecione uma empresa",
                    },
                  ]}
                >
                  <Select
                    optionFilterProp="labelSearch"
                    placeholder="Selecione uma empresa"
                    loading={empresaState.loading}
                    onChange={onChangeEmpresa}
                    style={{ width: "100%" }}
                    options={empresaState.list.map((a: EmpresaModel) => ({
                      value: a.id,
                      key: a.apelido,
                      label: (
                        <Flex justify="flex-start" align="center" gap={8} style={{ padding: "1px 0px" }}>
                          <div style={{ lineHeight: "0px" }}>{a.urlLogotipoPequeno && <Image width={25} height={25} style={{ lineHeight: "0px" }} src={a.urlLogotipoPequeno} preview={false} />}</div>
                          {a.apelido}
                        </Flex>
                      ),
                      labelSearch: a.apelido,
                    }))}
                  />
                </Form.Item>
              </Col>
            </>
          )}
          <Col span={4}>
            <Form.Item
              label="Conta banco"
              name="idContaBanco"
              rules={[
                {
                  required: true,
                  message: "Selecione uma conta banco",
                },
              ]}
            >
              <Select
                showSearch
                optionFilterProp="label"
                loading={contaBancoState.loading}
                options={contaBancoState.list.map((a: Vm_ContaBancoModel) => ({
                  value: a.id,
                  label: a.denominacaoPersonalizada,
                  disabled: !a.ativo,
                }))}
                disabled={contaFinanceiraState.origemCadastro === "pendencia"}
              />
            </Form.Item>
          </Col>
          <Col span={3}>
            <Form.Item
              label="Data do sorteio"
              name="idSorteio"
              rules={[
                {
                  required: exigeSorteio,
                  message: "Selecione o sorteio",
                },
              ]}
            >
              <Select
                showSearch
                optionFilterProp="label"
                loading={sorteioState.loadingEmpresas}
                options={sorteioState.listSorteioEmpresas.map((a: any) => ({
                  value: a.idSorteio,
                  label: dayjs(a.dataSorteio).format("DD/MM/YYYY"),
                }))}
                disabled={contaFinanceiraState.origemCadastro === "pendencia"}
              />
            </Form.Item>
          </Col>
          <Col span={5}>
            <Form.Item label="Tipo de documento" name="idTipoDocumento">
              <Select
                showSearch
                optionFilterProp="label"
                placeholder="Selecione o tipo de documento"
                allowClear
                loading={tipoDocumentoState.loading}
                options={tipoDocumentoState.list.map((a: any) => ({
                  value: a.id,
                  label: a.denominacao,
                }))}
                disabled={contaFinanceiraState.origemCadastro === "pendencia"}
              />
            </Form.Item>
          </Col>
          <Col span={5}>
            <Form.Item label="Número do documento" name="numeroDocumento">
              <Input type="text" disabled={contaFinanceiraState.origemCadastro === "pendencia"} />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={12}>
          <Col span={24}>
            <div style={{ display: "flex", flexDirection: "row", gap: "8px", width: "100%" }}>
              {pagar || contaFinanceiraState.origemCadastro === "guia" || lancamentoDespesa || lancamentoDespesa ? (
                <>
                  <Form.Item
                    label={"Fornecedor"}
                    name="idPessoa"
                    style={{ width: "100%" }}
                    rules={[
                      {
                        required: true,
                        message: "selecione um fornecedor",
                      },
                    ]}
                  >
                    <Select
                      showSearch
                      style={{ width: "100%" }}
                      optionFilterProp="label"
                      placeholder={"Selecione o fornecedor"}
                      onChange={onChangePessoa}
                      filterOption={(input: any, option: any) =>
                        (option?.label ?? "").toLowerCase().includes(input.toLowerCase()) || (option?.filter ?? "").toLowerCase().includes(input.toLowerCase())
                      }
                      loading={pessoaState.loading}
                      options={pessoaState.list.map((a: PessoaModel) => ({
                        value: a.id,
                        label: `${a.razaoSocial} - ${a.apelido}`,
                        filter: a.razaoSocial,
                        disabled: !a.ativo,
                      }))}
                      disabled={contaFinanceiraState.origemCadastro === "pendencia"}
                    />
                  </Form.Item>
                  <Form.Item label=" ">
                    <Button style={{ marginLeft: "-8px", height: "33px" }} onClick={goModalPessoa}>
                      <Icon.PlusSquareOutlined />
                    </Button>
                  </Form.Item>
                  <Form.Item
                    label="Favorecido"
                    name="idPessoaFavorecido"
                    style={{ width: "100%" }}
                    rules={[
                      {
                        required: true,
                        message: "selecione o favorecido",
                      },
                    ]}
                  >
                    <Select
                      showSearch
                      optionFilterProp="label"
                      placeholder="Selecione o favorecido"
                      filterOption={(input, option) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase()) || (option?.filter ?? "").toLowerCase().includes(input.toLowerCase())}
                      loading={pessoaState.loading}
                      options={pessoaState.list.map((a: PessoaModel) => ({
                        value: a.id,
                        label: `${a.razaoSocial} - ${a.apelido}`,
                        filter: a.razaoSocial,
                        disabled: !a.ativo,
                      }))}
                    />
                  </Form.Item>
                </>
              ) : (
                <>
                  <Form.Item
                    label={"Cliente"}
                    name="idPessoa"
                    style={{ width: "50%" }}
                    rules={[
                      {
                        required: true,
                        message: "selecione um cliente",
                      },
                    ]}
                  >
                    <Select
                      showSearch
                      style={{ width: "100%" }}
                      optionFilterProp="label"
                      placeholder={"Selecione o cliente"}
                      filterOption={(input, option) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase()) || (option?.filter ?? "").toLowerCase().includes(input.toLowerCase())}
                      onChange={onChangePessoa}
                      loading={pessoaState.loading}
                      options={pessoaState.list.map((a: PessoaModel) => ({
                        value: a.id,
                        label: `${a.razaoSocial} - ${a.apelido}`,
                        filter: a.razaoSocial,
                        disabled: !a.ativo,
                      }))}
                      disabled={contaFinanceiraState.origemCadastro === "pendencia"}
                    />
                  </Form.Item>
                  <Form.Item label=" ">
                    <Button style={{ marginLeft: "-8px", height: "33px" }} onClick={goModalPessoa}>
                      <Icon.PlusSquareOutlined />
                    </Button>
                  </Form.Item>
                </>
              )}
            </div>
          </Col>
        </Row>
        <Row gutter={12} style={{ width: 1100 }}>
          <Col span={4}>
            <Form.Item
              label="Data de emissão"
              name="dataEmissao"
              rules={[
                {
                  required: true,
                  message: "selecione uma data de emissão",
                },
              ]}
            >
              <DatePicker format={"DD/MM/YYYY"} onChange={onChangeDataEmissao} disabled={contaFinanceiraState.origemCadastro === "pendencia"} />
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item
              label="Data de vencimento"
              name="dataVencimento"
              rules={[
                {
                  required: true,
                  message: "selecione uma data de vencimento",
                },
              ]}
            >
              <DatePicker format={"DD/MM/YYYY"} disabled={contaFinanceiraState.origemCadastro === "pendencia"} />
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item
              label="Data de competência"
              name="dataCompetencia"
              rules={[
                {
                  required: true,
                  message: "selecione uma data de competência",
                },
              ]}
            >
              <DatePicker picker="month" format={"MM/YYYY"} disabled={contaFinanceiraState.origemCadastro === "pendencia"} />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item
              label="Status"
              name="idSituacaoContaFinanceira"
              rules={[
                {
                  required: true,
                  message: "selecione uma status",
                },
              ]}
            >
              <Select
                showSearch
                optionFilterProp="label"
                placeholder="Selecione o status"
                loading={contaFinanceiraState.loadingSituacao}
                options={contaFinanceiraState.listSituacao.map((a: any) => ({
                  value: a.id,
                  label: a.denominacao,
                  disabled: a.id === 4,
                }))}
                disabled={contaFinanceiraState.origemCadastro === "pendencia"}
              />
            </Form.Item>
          </Col>
          {pagar ||
            lancamentoDespesa ||
            (lancamentoDespesa && (
              <Col span={4}>
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                  <Form.Item
                    label="Numero parcela"
                    name="numeroParcela"
                    rules={[
                      {
                        validator: (_, value) => {
                          const quantidadeTotalParcela = form.getFieldValue("quantidadeTotalParcela");
                          if (value > quantidadeTotalParcela) {
                            return Promise.reject(new Error("Não pode ser maior que a quantidade total de parcelas."));
                          }
                          return Promise.resolve();
                        },
                      },
                    ]}
                  >
                    <NumericFormat className="ant-input noBoderColor number-input" disabled={contaFinanceiraState.origemCadastro === "pendencia"} />
                  </Form.Item>
                  <Form.Item label="Quantidade parcelas" name="quantidadeTotalParcela" style={{ marginLeft: "24px" }}>
                    <NumericFormat className="ant-input noBoderColor number-input" disabled={contaFinanceiraState.origemCadastro === "pendencia"} />
                  </Form.Item>
                </div>
              </Col>
            ))}
        </Row>
        <Row gutter={12}>
          <Col span={24}>
            <Form.Item label="Histórico" name="historico">
              <TextArea rows={3} disabled={contaFinanceiraState.origemCadastro === "pendencia"} />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={12} style={{ width: 1200 }}>
          <Col span={4}>
            <Form.Item
              label="Valor bruto"
              name="valorBruto"
              rules={[
                {
                  required: true,
                  message: "digite um valor",
                },
              ]}
            >
              <NumericFormat
                className="ant-input noBoderColor number-input"
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={2}
                prefix="R$"
                fixedDecimalScale={true}
                onBlur={() => {
                  if (form.getFieldValue("valorLiquido") === undefined) {
                    form.setFieldValue("valorLiquido", form.getFieldValue("valorBruto"));
                  }
                  if (totalItens === 0) {
                    formManual.setFieldValue("valor", realParaNumber(form.getFieldValue("valorBruto")));
                  }
                  setTotal(realParaNumber(form.getFieldValue("valorBruto")));
                }}
                onValueChange={(e) => {
                  form.setFieldValue("valorBruto", e.floatValue);
                }}
                onChange={() => {
                  form.setFieldValue("valorBruto", realParaNumber(form.getFieldValue("valorBruto")));
                }}
                disabled={contaFinanceiraState.origemCadastro === "pendencia"}
              />
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item
              label="Valor líquido"
              name="valorLiquido"
              rules={[
                {
                  required: true,
                  message: "Digite um valor",
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    const valorBruto = getFieldValue("valorBruto");
                    if (valorBruto !== undefined && value !== undefined) {
                      if (realParaNumber(value) > realParaNumber(valorBruto)) {
                        return Promise.reject("O valor deve ser inferior ao valor bruto");
                      }
                    }
                    return Promise.resolve();
                  },
                }),
              ]}
            >
              <NumericFormat
                className="ant-input noBoderColor number-input"
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={2}
                prefix="R$"
                fixedDecimalScale={true}
                onChange={() => form.setFieldValue("valorLiquido", realParaNumber(form.getFieldValue("valorLiquido")))}
                disabled={contaFinanceiraState.origemCadastro === "pendencia"}
              />
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item
              label="Valor pago"
              name="valorPago"
              rules={[
                {
                  required: true,
                  message: "digite um valor",
                },
              ]}
            >
              <NumericFormat
                className="ant-input noBoderColor number-input"
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={2}
                prefix="R$"
                fixedDecimalScale={true}
                onChange={() => form.setFieldValue("valorPago", realParaNumber(form.getFieldValue("valorPago")))}
                disabled
              />
            </Form.Item>
          </Col>
        </Row>
        <Divider orientation="left" orientationMargin="0">
          {pagar || contaFinanceiraState.origemCadastro === "guia" || lancamentoDespesa || lancamentoDespesa ? "Classificação da conta a pagar" : "Classificação da conta a receber"}
        </Divider>
        <Row gutter={12} style={{ marginBottom: 12 }} align="bottom">
          <Col span={24}>
            <Flex justify="end">
              <Radio.Group options={radioOptions} onChange={onChangeRadio} value={valueRadio} optionType="button" buttonStyle="solid" />
            </Flex>
          </Col>
        </Row>
        {valueRadio === "Rateio" ? (
          <Flex gap={12} vertical>
            <Row gutter={12} className="rateioHeader">
              SELECIONAR RATEIO DE CENTRO DE CUSTO
            </Row>
            <Flex className="rateioDentro" vertical>
              <Form form={formRateio}>
                <Row gutter={12} className="rateioForm">
                  <Col span={10}>
                    <Form.Item label="Plano de conta financeiro" name="idPlanoContaFinanceiro">
                      <SelectTree loading={planoContaFinanceiroState.loading} list={planoContaFinanceiroState.list} />
                    </Form.Item>
                  </Col>
                  <Col span={10}>
                    <Form.Item label="Rateio de centro de custo" name="idRateio">
                      <Select
                        showSearch
                        optionFilterProp="label"
                        loading={rateioCentroCustoState.loading}
                        onChange={(e) => formRateio.setFieldValue("idRateio", e)}
                        options={rateioCentroCustoState.list.map((a: any) => ({
                          value: a.id,
                          label: a.denominacao,
                          disabled: !a.ativo,
                        }))}
                        disabled={contaFinanceiraState.origemCadastro === "pendencia"}
                      />
                    </Form.Item>
                  </Col>
                  {!(contaFinanceiraState.origemCadastro === "pendencia") && (
                    <Col span={4} style={{ marginTop: 31 }}>
                      <Button className="buttonPrimary" onClick={gerarRateio} icon={<Icon.SelectOutlined />}>
                        GERAR
                      </Button>
                    </Col>
                  )}
                </Row>
              </Form>
              <Row gutter={12}>
                <Col span={24}>
                  <Table
                    size="small"
                    loading={contaFinanceiraState.loadingCalculo}
                    dataSource={formRateio.getFieldValue("idPlanoContaFinanceiro") === undefined ? [] : contaFinanceiraState.listCalculo}
                    columns={columnsRateio}
                    pagination={false}
                  />
                </Col>
              </Row>
            </Flex>
          </Flex>
        ) : (
          <Flex gap={12} vertical>
            <Row gutter={12} align="bottom">
              <Col span={4}>
                <Flex gap={12}>
                  <Form.Item label=" ">
                    <Button onClick={handleAdd} type="primary" icon={<Icon.PlusCircleOutlined />}>
                      Adicionar
                    </Button>
                  </Form.Item>
                </Flex>
              </Col>
              <Col span={20}>
                <Flex justify="end">
                  <Form.Item label="Total dos itens">
                    <NumericFormat
                      className="ant-input noBoderColor number-input"
                      thousandSeparator="."
                      decimalSeparator=","
                      decimalScale={2}
                      prefix="R$"
                      fixedDecimalScale={true}
                      disabled
                      value={totalItens}
                    />
                  </Form.Item>
                </Flex>
              </Col>
            </Row>
            <Form form={formManual} component={false}>
              <Row gutter={12} align="bottom">
                <Col span={24}>
                  <Form.Item>
                    <Table
                      size="small"
                      components={{
                        body: {
                          cell: EditableCell,
                        },
                      }}
                      rowClassName="editable-row"
                      dataSource={dataSource}
                      columns={mergedColumns}
                      pagination={false}
                      loading={contaFinanceiraState.loading}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Flex>
        )}
        <Row gutter={12}>
          <Col span={24} className="modalFooter">
            <Space size="middle">
              <Button disabled={contaFinanceiraState.loading} className="cancelButton" onClick={voltar} icon={<Icon.LeftOutlined />}>
                VOLTAR
              </Button>
              {!(contaFinanceiraState.origemCadastro === "pendencia") && (
                <Button htmlType="submit" icon={<Icon.CheckOutlined />} disabled={arquivoAnexoState.loading} className="buttonPrimary">
                  {editar ? (!(contaFinanceiraState.tipoAcao === "duplicar") ? "ATUALIZAR" : "DUPLICAR") : "SALVAR"}
                </Button>
              )}
            </Space>
          </Col>
        </Row>
      </Form>
      <Modal title={"ATENÇÃO"} centered width={350} open={contaFinanceiraState.modalVoltar} onCancel={closeModalVoltar} footer={null} destroyOnHidden>
        <>
          <Row gutter={12}>
            <Col span={24}>
              <Title level={5}>A alteração realizada na classificação da conta a pagar não foi atualizada e será perdida. Deseja continuar?</Title>
            </Col>
          </Row>
          <Divider />
          <Row gutter={12}>
            <Col span={24} className="modalFooter">
              <Space size="middle">
                <Button className="cancelButton" onClick={() => dispatch(setModalVoltarContaFinanceira(false))} icon={<Icon.CloseOutlined />}>
                  NÃO
                </Button>
                <Button className="buttonPrimary" onClick={voltar} icon={<Icon.CheckOutlined />}>
                  SIM
                </Button>
              </Space>
            </Col>
          </Row>
        </>
      </Modal>
      <Modal title={"ANEXOS"} centered width={1100} open={arquivoAnexoState.modalArquivo} onCancel={closeModalArquivo} footer={null} destroyOnHidden>
        <UploadArquivosComponent
          visualizar={contaFinanceiraState.origemCadastro === "pendencia" ? true : false}
          idOrigem={contaFinanceiraState.entity.id}
          contaCadastro={editar && !(contaFinanceiraState.tipoAcao === "duplicar") ? false : true}
          container={"contafinanceira"}
          origem={contaFinanceiraState.origemCadastro}
        />
      </Modal>
      <Modal title={"CADASTRO DE PESSOA"} centered width={900} open={contaFinanceiraState.modalPessoa} onCancel={closeModalPessoa} footer={null} destroyOnHidden>
        <ModalPessoaContaFinanceira origem={pagar || contaFinanceiraState.origemCadastro === "guia" || lancamentoDespesa || lancamentoDespesa ? "D" : "R"} />
      </Modal>
    </Flex>
  );
};

export default CadastrarPage;
